import { Component, OnInit, OnDestroy } from '@angular/core';
import { GearAppService, GearProxyService, GearTypes } from 'common-gear';
import { AppService, ColorPickerService, CoreProxyService, IMultiSelectOption,  IMultiSelectSettings, IMultiSelectTexts } from 'common-cloudstudio';
import { Subscription } from 'rxjs';
// import { resolve } from 'url';


@Component({
  selector: 'app-tanks',
  templateUrl: './tanks.component.html',
  styleUrls: ['./tanks.component.scss']
})
export class TanksComponent implements OnInit, OnDestroy {

  isCollapsed = true;
  _facilityID: number;
  data: GearTypes.GearTankSummaryFacility[] = [];
  facilitiesList: Array<IMultiSelectOption> = []; 
  materialsList: Array<IMultiSelectOption> = [];
  facilities: number[] = [];
  materials: number[] = [];
  timeout;
  checkInMaintenance: boolean = true;
  checkAlert: boolean = true; 
  checkNormal: boolean = true;
  destroyed = false;
  subscriptions: Subscription[] = [];
  listStatus = 0;

  tankStatus = {
    Normal: GearTypes.GearTankSummaryStatus.Normal,
    Error: GearTypes.GearTankSummaryStatus.Error,
    Maintenance: GearTypes.GearTankSummaryStatus.Maintenance,
  };
  
  _multiSelectSettings: IMultiSelectSettings = {
    enableSearch: true,
    checkedStyle: 'checkboxes',
    dynamicTitleMaxItems: 1,
    displayAllSelectedText: true,
    showCheckAll: true,
    showUncheckAll: true,
    selectionLimit: 10
  };

  _multiSelectTexts: IMultiSelectTexts = {
    checkAll: this._appService.CoreCommonLiterals.MultiSelect_All_Male, // 'Select all'
    uncheckAll: this._appService.CoreCommonLiterals.None_Male, // 'Unselect all'
    checked: this._appService.CoreCommonLiterals.MultiSelect_X_Selected_Male, // 'item selected'
    checkedPlural: this._appService.CoreCommonLiterals.MultiSelect_X_Selected_Male,
    searchPlaceholder: this._appService.CoreCommonLiterals.MultiSelect_Find, //'Find'
    defaultTitle: this._appService.CoreCommonLiterals.Select, // 'Select'
    allSelected: this._appService.CoreCommonLiterals.MultiSelect_All_Male // 'All selected'
  };
  
  constructor(
    public _appService: AppService,
    public _gearAppService: GearAppService,
    private _gearProxyService: GearProxyService,
    public colors: ColorPickerService,
    private _coreProxyService: CoreProxyService
  ) { }

  ngOnInit() {
     this.getMaterials().then(()=>{
       this.getFacilities().then(() =>{
        this.getData();
        this._facilityID = this._appService.getFacilityID();
       });     
     });

    this.subscriptions.push( this._gearAppService.onChangeFacilityID.subscribe( facilityID => {
      if (this._facilityID === facilityID) { return; }
      this._facilityID = this._appService.getFacilityID();
      this.facilities = [];
      this.materials = [];
      this.data = [];
      this.listStatus = 0;
      this.getMaterials().then(() => {
        this.getFacilities().then(() => {
          this.getData();
        });
      });
    }));
  }

  ngOnDestroy() {
    this.destroyed = true;
    if (this.timeout) { clearTimeout(this.timeout); }
    this.timeout = null;
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  getData() {
    if (this.destroyed) { return; }
    if (this.timeout) { clearTimeout(this.timeout); }
    this._gearProxyService.TanksService.GetTankSummary(
      this._appService.getAccessToken(),
      this._appService.getClientID(),
      this.facilities,
      this.materials,
      this.checkInMaintenance,
      this.checkAlert,
      this.checkNormal,
      res => {
        this.listStatus = 1;
        this.data = res;
        this.timeout = setTimeout(() => this.getData(), 5000);                  
      }, err => {
        this._appService.showException(err);     
        this.timeout = setTimeout(() => this.getData(), 15000);
      }
    );
  }

  getFacilities(): Promise<void> {
    this.facilities = [];
    this.facilitiesList = [];
    return new Promise((resolve, reject) => {
      let optionsList:  Array<IMultiSelectOption> = new Array<IMultiSelectOption>();
      this._coreProxyService.FacilityService.EnumFacilities(
        this._appService.getAccessToken(),
        this._appService.getClientID(),
        res => {
          res.forEach(x => {
            let item = {
              name: x.Description,
              id: x.FacilityID
            }
            optionsList.push(item);
            this.facilities.push(x.FacilityID);  
          });
          this.facilitiesList = optionsList;        
          resolve();
        }, 
        e => {
          reject(e);
        }
      );
    });
  }  

  getMaterials(): Promise<void> {
    this.materials = [];
    this.materialsList = [];
    return new Promise((resolve, reject)=>{
      let optionsList:  Array<IMultiSelectOption> = new Array<IMultiSelectOption>();
      this._gearProxyService.TanksService.EnumTankContentMaterials(
        this._appService.getAccessToken(),
        this._appService.getClientID(),
        res => {
          res.forEach(x => {
            let item = {
              name: x.Description,
              id: x.TankContentMaterialID
            }
            optionsList.push(item);
            this.materials.push(x.TankContentMaterialID);
          });
          this.materialsList = optionsList;
          resolve();
        },
        e => {
          reject(e);
        }        
      )
    })  
  }

  applyFilters() {  
    if (this.timeout) { clearTimeout(this.timeout); }
    this.timeout = setTimeout(() => this.getData(), 300);       
  }
}
